/**
 * B_World.js
 *
 * @목적 : World 클래스의 최상위 클래스입니다. createjs.container 를 상속받습니다.
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.02.20
 * @작성 : SuperMoon
 * @참조 :
 */

import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';

import B_ImageBG from 'canvas/base/dev/child/image/B_ImageBG'
import B_Util    from 'canvas/base/dev/util/B_Util';
import B_Define  from 'canvas/base/dev/util/B_Define';
import B_Real from 'canvas/base/dev/child/base/B_Real';
import B_Sprite from 'canvas/base/dev/child/sprite/B_Sprite';

let mix = (superclass) => new MixinBuilder(superclass);

const B_World = (function(){

	// [V]
	const $ = {
		_end : null, // 종료 {bol} - 다음 값을 확인해서 현재 월드가 종료됬는지 확인합니다.
		_list : null, // 리스트 {json} - 월드 리스트 객체
		_state : null, // 상태 {obj} - 게임 진행 상황
		tweenStorage : null // tween 저장소 {arr}
	};

	class B_World extends createjs.Container {

		constructor(cm) {
			super();

			// [S]
			this.CODMOS  = cm;
			this._end = false;
			this.tweenStorage = [];
			this.on("tick", this.tick);
		}

		// [V]

		// @DES :: mainBG {obj} 객체 - 객체 생성 및 적용
		getBG() { return this.mainBG; }
		setBG(img) {
			this.mainBG = new B_ImageBG({
				cm   : this.CODMOS,
				id   : B_Define.BG_ID,
				type : B_Define.BG_TYPE,
				res  : img
			});
			this.addChild(this.mainBG._container);   // [#] world 추가
			return B_Util.getProtected(this.mainBG); // [#] wrapper 추가
 		}

        // @DES :: mainBG 변경하기
        changeBG (img) {
            switch (typeof img) {
                case "object" :
                    this.mainBG._switchImage(img);
                    break;
                case "string" :
                    let image = new Image();
                    image.onload = () => {
                        this.mainBG._switchImage(image);
                    };
                    image.src = img;
                    break;
            }
        }

		// @DES :: markSuccess {obj} - 성공 마크
		get markSuccess() {
			if($._markSuccess == null) {
				$._markSuccess = new class extends mix(B_Real).with(B_Sprite) { constructor(obj) { super(obj); } }({
					cm : this.CODMOS,
					id : B_Define.MARK_SUCCESS_RES,
					res : B_Define.MARK_SUCCESS_RES,
					type : B_Define.TOOL_TYPE
				});
			}
			return $._markSuccess._object.clone();
		}

		// @DES :: markLack {obj} - 부족 마크
		get markLack() {
			if($._markLack == null) {
				$._markLack = new class extends mix(B_Real).with(B_Sprite) { constructor(obj) { super(obj); } }({
					cm : this.CODMOS,
					id : B_Define.MARK_LACK_RES,
					res : B_Define.MARK_LACK_RES,
					type : B_Define.TOOL_TYPE
				});
			}
			return $._markLack._object.clone();
		}

		// @DES :: markFail {obj} - 부족 마크
		get markFail() {
			if($._markFail == null) {
				$._markFail = new class extends mix(B_Real).with(B_Sprite) { constructor(obj) { super(obj); } }({
					cm : this.CODMOS,
					id : B_Define.MARK_FAIL_RES,
					res : B_Define.MARK_FAIL_RES,
					type : B_Define.TOOL_TYPE
				});
			}
			return $._markFail._object.clone();
		}

		// [F]

		/**
		 * @DES :: 자동화 메소드
		 * @S.E :: 하위 월드에서는 상속받아서 tick을 추가하는 방식으로 사용
		 */
		tick() { }

		/**
		 * @DES :: 리스트 처리 함수 (canvas, world)
		 * @IP1 :: list {arr}
		 * @S.E :: canvas 처리는 사용자에게 목록을 전할하기 위함
		 */
		initList (list) {
			// [#] world
			this.LIST = {};
			list.forEach((v)=>{
				this.LIST[v] = {};
			});
			// [#] canvas
			list.splice(0, 4);      // [all, real, unreal, obj] 제거
			this.CODMOS.LIST = list;
		}

		/**
		 * [ Function :: addObject ]
		 *
		 * @DES :: 객체 추가
		 * @IP1 :: obj {obj}
		 */
		addObject(obj) {
			try {
				// [E] id
				// if (!obj.id) { B_Util.print("[코드모스] => 객체를 생성하는데 필요한 ID가 없습니다."); return }
				if (this.CODMOS.WORLD[obj.id]) {
					B_Util.print("[코드모스] => 객체를 생성에 요청하신 아이디가 이미 존재합니다."); return
				}

				// [S] cm
				obj.cm = this.CODMOS;
			} catch (e) {
				B_Util.print('[ERROR] in addObject');
				B_Util.print(e);
			}
		}
	};

	B_Util.manageGetAndSet(B_World, $);
	return B_World;
}());

export default B_World;



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/frame/B_World.js